import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=c4eccca6&"
import script from "./ShareButtons.vue?vue&type=script&lang=js&"
export * from "./ShareButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4eccca6')) {
      api.createRecord('c4eccca6', component.options)
    } else {
      api.reload('c4eccca6', component.options)
    }
    module.hot.accept("./ShareButtons.vue?vue&type=template&id=c4eccca6&", function () {
      api.rerender('c4eccca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ShareButtons.vue"
export default component.exports